export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_a0821cf2-85fb-43dc-9357-0abfda152444/artifacts/coiwhsxz_Gemini_Generated_Image_716by5716by5716b.jfif";

export const IMAGES = {
  hero: "https://images.pexels.com/photos/17092455/pexels-photo-17092455.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  heroAlt:
    "https://images.unsplash.com/photo-1708582884245-b0de089d75c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcG9ydHMlMjBjYXIlMjBkYXJrJTIwc3R1ZGlvfGVufDB8fHxibGFja3wxNzkwMjkyMTQyfDA&ixlib=rb-4.1.0&q=85",
  craftHands:
    "https://images.pexels.com/photos/10126663/pexels-photo-10126663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  workshop:
    "https://images.pexels.com/photos/10126657/pexels-photo-10126657.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  greenCar:
    "https://images.unsplash.com/photo-1779263439734-de7557f6c10b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxjYXIlMjB3cmFwJTIwdmlueWwlMjBpbnN0YWxsZXIlMjBleG90aWMlMjBjYXJ8ZW58MHx8fHwxNzkwMjkyMTQyfDA&ixlib=rb-4.1.0&q=85",
  orangeCar:
    "https://images.unsplash.com/photo-1785779243686-f9eb7b86be77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxjYXIlMjB3cmFwJTIwdmlueWwlMjBpbnN0YWxsZXIlMjBleG90aWMlMjBjYXJ8ZW58MHx8fHwxNzkwMjkyMTQyfDA&ixlib=rb-4.1.0&q=85",
  blackCar:
    "https://images.unsplash.com/photo-1770172505563-d1d71c6f158e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxjYXIlMjB3cmFwJTIwdmlueWwlMjBpbnN0YWxsZXIlMjBleG90aWMlMjBjYXJ8ZW58MHx8fHwxNzkwMjkyMTQyfDA&ixlib=rb-4.1.0&q=85",
  redCar:
    "https://images.unsplash.com/photo-1769540070615-149f4e942a45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxjYXIlMjB3cmFwJTIwdmlueWwlMjBpbnN0YWxsZXIlMjBleG90aWMlMjBjYXJ8ZW58MHx8fHwxNzkwMjkyMTQyfDA&ixlib=rb-4.1.0&q=85",
  detailBay:
    "https://images.unsplash.com/photo-1619405399517-d7fce0f13302?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxhdXRvbW90aXZlJTIwY2VyYW1pYyUyMGNvYXRpbmclMjBjYXIlMjBkZXRhaWxpbmclMjBnYXJhZ2V8ZW58MHx8fHwxNzkwMjkyMjQ1fDA&ixlib=rb-4.1.0&q=85",
  polishing:
    "https://images.unsplash.com/photo-1617814076367-b759c7d7e738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxhdXRvbW90aXZlJTIwY2VyYW1pYyUyMGNvYXRpbmclMjBjYXIlMjBkZXRhaWxpbmclMjBnYXJhZ2V8ZW58MHx8fHwxNzkwMjkyMjQ1fDA&ixlib=rb-4.1.0&q=85",
};

export const VEHICLES = [
  {
    id: "gwagon",
    name: "2026 Mercedes-AMG G 63",
    desc: "G-Wagon box-body profile",
    base: 5400,
    img: "/vehicles/gwagon.jpg",
    mask: "/vehicles/gwagon-mask.png",
    hoodMask: "/vehicles/gwagon-hood.png",
    roofMask: "/vehicles/gwagon-roof.png",
    trimMask: "/vehicles/gwagon-trim.png",
    glassMask: "/vehicles/gwagon-glass.png",
    tintPrice: 449,
    calipers: [
      { x: 23, y: 71, size: 7 },
      { x: 76.5, y: 71, size: 7 },
    ],
    decalZone: { x: 46, y: 55 },
  },
  {
    id: "trx",
    name: "Ram 1500 TRX",
    desc: "Supercharged crew-cab truck profile",
    base: 4800,
    img: "/vehicles/trx.jpg",
    mask: "/vehicles/trx-mask.png",
    hoodMask: "/vehicles/trx-hood.png",
    roofMask: "/vehicles/trx-roof.png",
    trimMask: "/vehicles/trx-trim.png",
    glassMask: "/vehicles/trx-glass.png",
    tintPrice: 429,
    calipers: [
      { x: 23.5, y: 68.5, size: 7.5 },
      { x: 78, y: 68.5, size: 7.5 },
    ],
    decalZone: { x: 62, y: 58 },
  },
  {
    id: "darkhorse",
    name: "2026 Mustang Dark Horse",
    desc: "5.0L V8 fastback profile",
    base: 3200,
    img: "/vehicles/darkhorse.jpg",
    mask: "/vehicles/darkhorse-mask.png",
    hoodMask: "/vehicles/darkhorse-hood.png",
    roofMask: "/vehicles/darkhorse-roof.png",
    trimMask: "/vehicles/darkhorse-trim.png",
    glassMask: "/vehicles/darkhorse-glass.png",
    tintPrice: 349,
    calipers: [
      { x: 21, y: 57.5, size: 6 },
      { x: 76.5, y: 57.5, size: 6 },
    ],
    decalZone: { x: 44, y: 57 },
  },
  {
    id: "porsche911",
    name: "Porsche 911 S",
    desc: "Carrera fastback coupe profile",
    base: 4200,
    img: "/vehicles/porsche911.jpg",
    mask: "/vehicles/porsche911-mask.png",
    hoodMask: "/vehicles/porsche911-hood.png",
    roofMask: "/vehicles/porsche911-roof.png",
    trimMask: "/vehicles/porsche911-trim.png",
    glassMask: "/vehicles/porsche911-glass.png",
    tintPrice: 349,
    calipers: [
      { x: 25, y: 60, size: 6.5 },
      { x: 76.5, y: 60, size: 6.5 },
    ],
    decalZone: { x: 44, y: 58 },
  },
];

export const FINISHES = [
  { id: "matte", name: "Stealth Matte", multiplier: 0.95, note: "Flat, zero-reflection finish" },
  { id: "satin", name: "Satin", multiplier: 1.0, note: "Soft diffused sheen" },
  { id: "gloss", name: "High Gloss", multiplier: 1.05, note: "Wet-look mirror depth" },
];

export const COLORS = [
  { id: "vampire_red", name: "Vampire Velvet Red", hex: "#8A0B16", accent: "#FF4D5E" },
  { id: "stealth_black", name: "Obsidian Stealth Black", hex: "#141518", accent: "#4B5563" },
  { id: "nardo_grey", name: "Battleship Nardo Grey", hex: "#767C82", accent: "#A0A7AE" },
  { id: "racing_green", name: "Atelier Racing Green", hex: "#0D2E1C", accent: "#1FB362" },
  { id: "frozen_blue", name: "Frozen Marina Blue", hex: "#1E4B8A", accent: "#38BDF8" },
  { id: "liquid_copper", name: "Molten Sunburst Copper", hex: "#BD5319", accent: "#FB923C" },
  { id: "midnight_purple", name: "Midnight Hyper Purple", hex: "#301347", accent: "#C084FC" },
  { id: "chalk_white", name: "Ceramic Chalk White", hex: "#E2E4E6", accent: "#FFFFFF" },
  { id: "speed_yellow", name: "Volt Competition Yellow", hex: "#EAB308", accent: "#FDE047" },
  { id: "emerald_mint", name: "Cyber Emerald Green", hex: "#047857", accent: "#34D399" },
];

export const ACCENTS = [
  { id: "hood_blackout", name: "Satin Carbon Hood", price: 450 },
  { id: "roof_pillars", name: "Gloss Black Roof & Pillars", price: 550 },
  { id: "chrome_delete", name: "Full Chrome Delete", price: 750 },
  { id: "calipers_red", name: "G5 Race Red Calipers", price: 380 },
  { id: "ceramic_over_wrap", name: "Ceramic Pro Over-Coat", price: 890 },
];

export const DECAL_SHAPES = [
  { id: "windshield", name: "Curved Windshield Sunstrip", ratio: 4, base: 89 },
  { id: "door_shield", name: "Race Door Number Board", ratio: 1, base: 59 },
  { id: "side_script", name: "Lower Rocker Lettering", ratio: 6, base: 79 },
  { id: "tailgate", name: "Rear Wing / Tailgate Badge", ratio: 3, base: 49 },
];

export const DECAL_FONTS = [
  { id: "speed", name: "Apex Drift", className: "font-display font-black italic tracking-tighter" },
  { id: "mono", name: "Tech Telemetry", className: "font-mono font-bold tracking-widest" },
  { id: "heavy", name: "Atelier Heavy", className: "font-display font-black tracking-normal uppercase" },
  { id: "stencil", name: "Trophy Stencil", className: "font-sans font-bold tracking-[0.3em] uppercase" },
];

export const DECAL_COLORS = [
  { name: "High-Gloss White", hex: "#FFFFFF" },
  { name: "Matte Dark Carbon", hex: "#1E2024" },
  { name: "G5 Signature Red", hex: "#FF2A3B" },
  { name: "Reflective Silver", hex: "#CBD5E1" },
  { name: "Optic Neon Lime", hex: "#A3E635" },
  { name: "Metallic Gold Leaf", hex: "#F59E0B" },
];
